<template>
  <div>
    <v-app-bar
      color="#FBC02D"
      dark>
      <h3>
        <v-icon>mdi-file-chart</v-icon>
        D. 詳細表の作成
      </h3>
    </v-app-bar>
    <stepper
      v-model="step"
      session-key-prefix="detail-step"
      :items="steps" />
    <detail-form-step1
      v-if="step===1"
      @change="goStep" />
    <detail-form-step2
      v-if="step===2"
      :statuses="statuses"
      :reasons="reasons"
      :samplings="samplings"
      :results="results"
      :sampling-results="samplingResults"
      :has-asbestos-types="hasAsbestosTypes"
      :asbestos-types="asbestosTypes"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <detail-form-step3
      v-if="step===3"
      :id="id"
      @hasChange="fetchIsChanged"
      @change="goStep" />
  </div>
</template>

<script>
import DetailFormStep1 from './FormStep1'
import DetailFormStep2 from './FormStep2'
import DetailFormStep3 from './FormStep3'
import Stepper from '../Stepper'

import LeaveConfirm from '../../mixins/LeaveConfirm'

export default {
  name: 'DetailForm',
  components: {
    Stepper,
    DetailFormStep1,
    DetailFormStep2,
    DetailFormStep3,
  },
  mixins: [LeaveConfirm],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      default: () => ([
        { id: 1, title: '整合性確認表の選択' },
        { id: 2, title: '詳細表の入力' },
        { id: 3, title: '詳細表の保存' },
      ]),
    },
  },
  data() {
    return {
      statuses: [],
      reasons: [],
      samplings: [],
      results: [],
      samplingResults: [],
      hasAsbestosTypes: [],
      asbestosTypes: [],
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get('/api/details/props')
      this.statuses = data.statuses
      this.reasons = data.reasons
      this.samplings = data.samplings
      this.results = data.results
      this.samplingResults = data.sampling_results
      this.hasAsbestosTypes = data.has_asbestos_types
      this.asbestosTypes = data.asbestos_types
    },
    goStep(step) {
      this.$router.push({ name: `detailEditStep${step}` })
    },
  },
}
</script>
